import { PropsWithChildren } from 'react'

import { createGenericContext } from '@/Shared/ui/createGenericContext'
import { UserRepository } from '@/User/domain'
import { IUseUserController, useUserController } from '@/User/ui/hooks'

type Context = {
  repository: UserRepository
} & IUseUserController

type Props = PropsWithChildren & {
  repository: UserRepository
}

const [useUserData, StateContextProvider] = createGenericContext<Context>()

const UserDataProvider = ({ repository, children }: Props): JSX.Element => {
  const controller = useUserController(repository)
  return (
    <StateContextProvider value={{ repository, ...controller }}>
      {children}
    </StateContextProvider>
  )
}

export { UserDataProvider, useUserData }
